/**
 * App-wide jurisdiction, sourced from the SafeCurves metadata summary table's
 * `jurisdiction` field (e.g. 'Australia', 'USA'); until that read resolves it
 * is DEFAULT_JURISDICTION. Selects the sign standard used for the map sprite
 * (see `loadMapSprites.ts` in the app directory).
 */

export type Jurisdiction = 'AUS' | 'USA';

const DEFAULT_JURISDICTION: Jurisdiction = 'USA';

// Metadata `jurisdiction` values (lower-cased) mapped to sign-standard codes.
const jurisdictionsByName: Record<string, Jurisdiction> = {
	australia: 'AUS',
	usa: 'USA'
};

function createJurisdictionStore() {
	let jurisdiction = $state<Jurisdiction>(DEFAULT_JURISDICTION);
	return {
		get jurisdiction(): Jurisdiction {
			return jurisdiction;
		},
		/** Applies the metadata table's jurisdiction name; unrecognised values leave the default in place. */
		setFromMetadata(row: { jurisdiction?: string | number | null }) {
			if (row.jurisdiction == null) return;
			const match = jurisdictionsByName[String(row.jurisdiction).trim().toLowerCase()];
			if (match) jurisdiction = match;
		}
	};
}

export const jurisdictionStore = createJurisdictionStore();
